import enumPart from './enumPart';

// util
import objectHelper from '../util/objectHelper';

export default objectHelper.merge(enumPart, {

    // 'SUPER' : {
    //     type : 'super',
    //     code : 1,
    //     title : '超级SVIP'
    // },
    // 'COURSE_VOD' : {
    //     type : 'course_vod',
    //     code : 2,
    //     title : '精品课程VIP'
    // },
    'DATUM' : {
        type : 'datum',
        code : 3,
        title : '师讯文库会员'
    },
    // 'POSTER_TOOL' : {
    //     type : 'poster_tool',
    //     code : 4,
    //     title : '海报工具'
    // },
    // 'COURSE_WARE' : {
    //     type : 'course_ware',
    //     code : 5,
    //     title : '课件网'
    // },
    // 'ATLAS' : {
    //     type : 'atlas_vip',
    //     code : 6,
    //     title : '精美环创VIP'
    // },
    // 'DISTRIBUTOR' : {
    //     type : 'distributor',
    //     code : 7,
    //     title : '分销员'
    // },
    // 'AGENCY' : {
    //     type : 'agency',
    //     code : 8,
    //     title : '代理商'
    // },

});
